module.exports = __webpack_public_path__ + "static/media/background.e7413352.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/login/background.jpg
// module id = 1046
// module chunks = 0